/* eslint-disable react/destructuring-assignment */
import React from "react";

const PlusOutLinedJSX = props => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      {...props}
      height="12"
      viewBox="0 0 12 12"
      fill="none"
    >
      <path
        d="M6 2.875V9.125"
        stroke={props?.color || "#3B82F6"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.125 6H2.875"
        stroke={props?.color || "#3B82F6"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default PlusOutLinedJSX;
